import React, { useEffect } from "react";
import { PageWrapper, Navbar, LiquidationEvent, Popup } from "./Components";
import {
  // Dashboard,
  Stake,
  Borrow,
  Pool,
  Loading,
  LiquidationCalculator,
  // Stats,
} from "./Screens";
import Redemption from "./Screens/Redemption";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { useLiquity } from "./Hooks/LiquityContext";
import { LiquityStoreProvider } from "@yeti/lib-react";
import { StabilityViewProvider } from "./PageComponents/Pool/context/StabilityViewProvider";
import { QueryClient, QueryClientProvider } from "react-query";
import { TransactionMonitor } from "./Components/Transaction";
import { Box, Button, useDisclosure } from "@chakra-ui/react";
import StrategiesCalculator from "./PageComponents/StrategiesCalculator";
import Footer from "./Components/Footer";
import Profile from "./Screens/Profile";
import { useWeb3Context } from "./Hooks/useWeb3Context";
import ReactGa from "react-ga";
import { useLocation } from "react-router-dom";
import Terms from "./Screens/Terms";
import TokenGraph from "./PageComponents/TokenGraph";
// import { Banner } from "./Components/Banner/Banner";
import Info from "./Screens/Info";
import PSM from "./Screens/PSM";
import { useProtocolDataContext } from "./Hooks/useProtocolDataContext";
// import { Banner } from "./Components/Banner/Banner";
import { Link } from "react-router-dom";
import { Center, Text } from "@chakra-ui/react";
import Snowfall from "react-snowfall";

interface WrapperProps {
  intialized: boolean;
  children: React.PropsWithChildren<any>;
}

export function Wrapper(props: WrapperProps) {
  const location = useLocation();

  React.useEffect(() => {
    if (props.intialized) {
      // console.log("pageview", location.pathname, location.search);
      ReactGa.pageview(location.pathname + location.search);
    }
  }, [props.intialized, location]);

  return props.children;
}

export function useAnalytics() {
  const [initialized, setInitalized] = React.useState(false);

  useEffect(() => {
    ReactGa.initialize("UA-239245708-2");

    setInitalized(true);
  }, []);

  return { initialized };
}

const YetiFrontend: React.FC = () => {
  const { liquity, account } = useLiquity();
  const { connected } = useWeb3Context();
  const queryClient = new QueryClient();
  const { isBlockedCountry, showApp, setShowApp } = useProtocolDataContext();

  let agreedToDisclaimer;
  useEffect(() => {
    if (
      localStorage.getItem(account + "agreedToYetiFinanceDisclaimerMainnet") ==
      undefined
    ) {
      agreedToDisclaimer = true;
    } else {
      agreedToDisclaimer = false;
    }
  }, [localStorage.getItem(account + "agreedToYetiFinanceDisclaimerMainnet")]);

  let borrowInfograph;
  if (
    localStorage.getItem(account + "agreedToYetiBorrowInfograph") == undefined
  ) {
    borrowInfograph = true;
  } else {
    borrowInfograph = false;
  }

  let farmInfograph;

  if (
    localStorage.getItem(account + "agreedToYetiFarmInfograph") == undefined
  ) {
    farmInfograph = true;
  } else {
    farmInfograph = false;
  }

  let veYETIInfograph;

  if (
    localStorage.getItem(account + "agreedToYetiveYETIInfograph") == undefined
  ) {
    veYETIInfograph = true;
  } else {
    veYETIInfograph = false;
  }
  const { isOpen: isAddCollateralTypeOpen, onClose: onAddCollateralTypeClose } =
    useDisclosure({
      defaultIsOpen: true,
    });

  const { isOpen: isBorrowOpen, onClose: onBorrowOpen } = useDisclosure({
    defaultIsOpen: true,
  });

  const { isOpen: isStakeOpen, onClose: onStakeOpen } = useDisclosure({
    defaultIsOpen: true,
  });

  const { isOpen: isFarmOpen, onClose: onFarmOpen } = useDisclosure({
    defaultIsOpen: true,
  });

  const { initialized } = useAnalytics();

  if (isBlockedCountry && !showApp) {
    return (
      <>
        <Center w="100vw" h="100vh" flexDirection="column" p={10}>
          <Snowfall snowflakeCount={100} style={{ zIndex: 1 }} />
          {/* <img src="/img/3d.png" alt="Yeti Finance" style={{ width: "6rem" }} /> */}
          <Text
            fontSize="25px"
            color="text-secondary"
            width={"60%"}
            align={"center"}
          >
            <span>
              Yeti Finance is not avaliable to people or companies who are
              residents of, or are located, incorporated or have a registered
              agent in, the US or a sanctioned territory. More details can be
              found in our
            </span>
            <Link to="/terms">
              <span
                style={{
                  color: "#5F81F9",
                  marginLeft: "4px",
                  fontWeight: "600",
                  marginRight: "4px",
                }}
              >
                Terms of Use
              </span>
            </Link>
          </Text>
          <Text
            fontSize="25px"
            color="text-secondary"
            width={"60%"}
            align={"center"}
            marginTop={"100px"}
          >
            <span>
              You may withdraw or adjust your existing position if you already
              have a trove open.
            </span>
          </Text>
          <Button
            onClick={() => {
              setShowApp(true);
            }}
            variant="newPrimary"
            width="fit"
            h="52px"
            mt="80px"
          >
            Adjust My Trove
          </Button>
        </Center>
      </>
    );
  }

  return (
    <LiquityStoreProvider loader={<Loading />} store={liquity.store}>
      <QueryClientProvider client={queryClient}>
        <Router>
          <StabilityViewProvider>
            {/* <Announcement /> */}
            <LiquidationEvent />
            {/* <Banner /> */}
            <>
              <Wrapper intialized={initialized}>
                <PageWrapper>
                  <Navbar walletConnected={connected} dashboardVisible={true} />
                  {/* <Box bg="surface" w="80px" h="94vh" position="fixed" left="32px" top="32px" bottom="32px"></Box> */}
                  {/* <Banner /> */}
                  {/* <Box
                  w="300px"
                  position="fixed"
                  left="0px"
                  top="0px"
                  bottom="0px"
                  bg="surface"
                >
                  sidebar
                </Box> */}
                  <Switch>
                    <Route path="/borrow">
                      {/* {borrowInfograph && (
                      <Popup
                        isOpen={isBorrowOpen}
                        onClose={onBorrowOpen}
                        header="Borrow"
                        infographSrc="/img/borrowdiagram.png"
                        mode="borrow"
                      />
                    )} */}
                      <Borrow />
                    </Route>
                    <Route path="/farm">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      {/* {farmInfograph && (
                      <Popup
                        isOpen={isFarmOpen}
                        onClose={onFarmOpen}
                        header="Farm"
                        infographSrc="/img/farm2.png"
                        mode="farm"
                      />
                    )} */}
                      <Pool />
                    </Route>
                    <Route path="/veYETI">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      {/* {veYETIInfograph && (
                      <Popup
                        isOpen={isStakeOpen}
                        onClose={onStakeOpen}
                        header="YETI Staking"
                        infographSrc="/img/stakediagram.png"
                        mode="veYETI"
                      />
                    )} */}
                      <Stake />
                    </Route>

                    <Route path="/PSM">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <PSM />
                    </Route>

                    <Route path="/terms">
                      {/* {veYETIInfograph && (
                      <Popup
                        isOpen={isStakeOpen}
                        onClose={onStakeOpen}
                        header="YETI Staking"
                        infographSrc="/img/stakediagram.png"
                        mode="veYETI"
                      />
                    )} */}
                      <Terms />
                    </Route>

                    <Route path="/info">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <Info />
                    </Route>
                    <Route path="/vault/:token">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <TokenGraph />
                    </Route>
                    <Route path="/profile">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <Profile walletConnected={connected} />
                    </Route>

                    {/* <Route path="/stats">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <Stats />
                    </Route> */}
                    <Route path="/calculator">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <LiquidationCalculator />
                    </Route>
                    <Route path="/strategies">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <StrategiesCalculator />
                    </Route>
                    <Route path="/redemption">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <Redemption />
                    </Route>
                    <Route path="/">
                      {localStorage.getItem(
                        account + "agreedToYetiFinanceDisclaimerMainnet"
                      ) == undefined && (
                        <Popup
                          isOpen={isAddCollateralTypeOpen}
                          onClose={onAddCollateralTypeClose}
                          header="Disclaimer: Risks of Using Protocol"
                        />
                      )}
                      <Borrow />
                    </Route>
                  </Switch>
                  <Box
                    display="flex"
                    w="full"
                    py="16px"
                    justifyContent="center"
                    alignItems="flex-end"
                    h="full"
                  >
                    <Footer />
                  </Box>
                </PageWrapper>
              </Wrapper>
            </>
          </StabilityViewProvider>
        </Router>
      </QueryClientProvider>
      <TransactionMonitor />
    </LiquityStoreProvider>
  );
};

export default YetiFrontend;
